export default {
  methods: {
    async formSubmit() {
      this.loading = true;
      const hasErrors = !this.$refs.vfg.validate();
      if (hasErrors) {
        window.scrollTo(0, 0);
      } else {
        try {
          const rowId = this.submitId || "new";
          const response = (await this.$axios({
            url: `forms/client/${this.$route.params.formId}/${rowId}`,
            method: "post",
            data: { answers: this.model }
          })).data;
          if (response.error) {
            throw `${response.error}: ${response.message}`;
          }
          this.$router.replace({
            name: "Complete",
            params: {
              formId: this.$route.params.formId,
              rowId: rowId === "new" ? response.results.id : rowId
            }
          });
          return;
        } catch (e) {
          alert(e);
        }
      }
      this.loading = false;
    }
  }
};
